import adminRequest from 'services/adminRequest';

export function resourcesGetCurrentUser(token) {
    console.log('resourcesGetCurrentUser', token);
    const payload = JSON.parse(atob(token.split('.')[1]));

    const userId = payload['https://geothentic.com/user_id'];

    const url = `users/${userId}`;

    return adminRequest(
        url,
        {
            method: 'GET',
        },
        false,
        token
    );
}
